import React from 'react'
import { useParams } from 'react-router-dom'
import { Profilebar, ProfileThumbnailArea } from './Profilebar'
import './Profile.css'

export default function Profile(props: any) {
  const uid: string | undefined = useParams().uid

  window.scrollTo(0, 0)
  return (
    <div>
      <Profilebar profid={uid} />
      <hr className="profile-border" />
      <h1 className="thumbnailarea-title">
        <span>わたしのおすすめ</span>
      </h1>
      <ProfileThumbnailArea profid={uid} multiline={true} />
    </div>
  )
}
